<script setup>
import PrintNodeForm from '@frontJs/components/forms/projectManagement/customers/externalServices/PrintNodeForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, externalService } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    externalService: {
        type: Object,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            PrintNode - Services externes - Clients - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - Clients - Services externes - PrintNode
    </PageTitle>

    <PrintNodeForm :tenant="tenant" :external-service="externalService" />
</template>
